import type { RiveFile } from '@rive-app/react-canvas';
import { makeAutoObservable } from 'mobx';

export class RiveFileStore {
  public allFilesToPreload: string[] = [];
  public riveFileMap = new Map<string, RiveFile | undefined>();

  constructor() {
    makeAutoObservable(this);
  }

  addFileToPreload(url: string) {
    if (!this.allFilesToPreload.includes(url)) {
      this.allFilesToPreload.push(url);
    }
  }

  setFile(url: string, file?: RiveFile) {
    this.riveFileMap.set(url, file);
  }

  getFile(url?: string) {
    if (!url) {
      return;
    }
    return this.riveFileMap.get(url);
  }
}
